import React from 'react';
import './button.styles.scss';
import { Link } from 'react-router-dom';

const Button = ({buttonLink, children, disabled, style, type, ...otherItemProps}) => {
return(
    <div>
    {buttonLink?<ButtonWithLinks className="custom-button" buttonLink={buttonLink} children={children} disabled={disabled} {...otherItemProps} style={{style}} type={type} />:<ButtonWithoutLinks children={children}  className="custom-button" disabled={disabled} {...otherItemProps} style={{style}} type={type}/>}
    </div>
    );
}

const ButtonWithLinks = ({children, buttonLink, disabled, style, type, ...otherItemProps}) => (
<Link to={`/${buttonLink}`}>
{console.log(buttonLink)}
<button className="custom-button" disabled={disabled} {...otherItemProps} style={{style}} type={type}>
{children}
</button>
</Link>
);

const ButtonWithoutLinks = ({children, disabled, style, type, ...otherItemProps}) => (
<button className="custom-button" disabled={disabled} {...otherItemProps} style={{style}} type={type}>
{children}
</button>
)
export default Button;